{
  "viewBox": {
    "w": 1030,
    "h": 508
  },
  "nodes": [
    {
      "id": "api-gw",
      "label": "API Gateway",
      "tier": 0,
      "x": 40,
      "y": 220,
      "w": 150,
      "h": 62,
      "cx": 115,
      "cy": 251
    },
    {
      "id": "lambda",
      "label": "Lambda",
      "tier": 1,
      "x": 240,
      "y": 220,
      "w": 150,
      "h": 62,
      "cx": 315,
      "cy": 251
    },
    {
      "id": "bedrock",
      "label": "Bedrock",
      "tier": 2,
      "x": 440,
      "y": 350,
      "w": 150,
      "h": 62,
      "cx": 515,
      "cy": 381
    },
    {
      "id": "s3",
      "label": "S3",
      "tier": 3,
      "x": 640,
      "y": 90,
      "w": 150,
      "h": 62,
      "cx": 715,
      "cy": 121
    },
    {
      "id": "dynamo",
      "label": "DynamoDB",
      "tier": 3,
      "x": 640,
      "y": 220,
      "w": 150,
      "h": 62,
      "cx": 715,
      "cy": 251
    },
    {
      "id": "ddb-snap",
      "label": "Snapshot",
      "tier": 4,
      "x": 840,
      "y": 220,
      "w": 150,
      "h": 62,
      "cx": 915,
      "cy": 251
    }
  ],
  "edges": [
    {
      "id": "e0",
      "from": "api-gw",
      "to": "lambda",
      "points": [
        {
          "x": 190,
          "y": 251
        },
        {
          "x": 240,
          "y": 251
        }
      ]
    },
    {
      "id": "e1",
      "from": "lambda",
      "to": "dynamo",
      "points": [
        {
          "x": 390,
          "y": 251
        },
        {
          "x": 640,
          "y": 251
        }
      ]
    },
    {
      "id": "e2",
      "from": "lambda",
      "to": "s3",
      "points": [
        {
          "x": 390,
          "y": 251
        },
        {
          "x": 515,
          "y": 251
        },
        {
          "x": 515,
          "y": 121
        },
        {
          "x": 640,
          "y": 121
        }
      ]
    },
    {
      "id": "e3",
      "from": "lambda",
      "to": "bedrock",
      "points": [
        {
          "x": 390,
          "y": 251
        },
        {
          "x": 515,
          "y": 251
        },
        {
          "x": 515,
          "y": 350
        }
      ]
    },
    {
      "id": "e4",
      "from": "dynamo",
      "to": "ddb-snap",
      "points": [
        {
          "x": 790,
          "y": 251
        },
        {
          "x": 840,
          "y": 251
        }
      ]
    }
  ]
}
